import { render, staticRenderFns } from "./ExemptionCertificatesDrawer.vue?vue&type=template&id=9f630ed4&scoped=true&"
import script from "./ExemptionCertificatesDrawer.vue?vue&type=script&lang=js&"
export * from "./ExemptionCertificatesDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f630ed4",
  null
  
)

export default component.exports